import { Row } from '../common/forms/layout.js';
import { Column2 } from '../common/forms/layout.js';
import { Column3 } from '../common/forms/layout.js';
import { Column4 } from '../common/forms/layout.js';
import { Column5 } from '../common/forms/layout.js';
import { Column6 } from '../common/forms/layout.js';
import { Column8 } from '../common/forms/layout.js';
import { Column9 } from '../common/forms/layout.js';
import { Column12 } from '../common/forms/layout.js';

const fields = {
    datum_probe: {
        key: 'datum_probe',
        type: 'datepicker',
        templateOptions: {
            label: 'Datum probe',
            required: true
        }
    },
    termin_probe: {
        key: 'termin_probe',
        type: 'timepicker',
        templateOptions: {
            label: 'Termin',
            required: true
        }
    },
    tehnicar: {
        key: 'tehnicar',
        type: 'uiSelect',
        templateOptions: {
            label: 'Tehničar',
            optionsAttr: 'bs-options',
            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
            valueProp: 'id',
            labelProp: 'naziv',
            placeholder: 'Odaberite tehničara',
            options: []
        },
        controller: [
            '$scope',
            'DS',
            function($scope, DS) {
                DS.findAll('Tehnicar').then(function(response) {
                    $scope.to.options = response;
                });
            }
        ]
    },
    napomena: {
        key: 'napomena',
        type: 'textarea',
        templateOptions: {
            label: 'Napomena',
            rows: 4
        }
    }
};

export default function(ac, app) {
    var entity = app.getEntity('FazaNaloga');
    entity
        .listView()
        .title('Faze naloga')
        .fields([
            ac
                .field('datum_probe', 'date')
                .label('Datum probe')
                .cssClasses(['col-md-2']),
            ac
                .field('termin_probe')
                .label('Termin')
                .cssClasses(['col-md-1']),
            ac
                .field('tehnicar', 'reference')
                .targetEntity(app.getEntity('Tehnicar'))
                .targetField(ac.field('naziv'))
                .label('Tehničar')
                .cssClasses(['col-md-2']),
            ac.field('napomena').cssClasses(['col-md-5'])
        ])
        .listActions(['delete']);

    entity.dashboardView().fields([
        ac
            .field('ordinacija_naziv', 'template')
            .label('Ordinacija')
            .template(entry => {
                return `<h4 class="font-extra-bold">${entry.ordinacija_naziv}</h4>`;
            }),
        ac.field('pacijent_naziv').label('Pacijent'),
        ac
            .field('radni_nalog_broj_naloga', 'template')
            .label('Radni nalog')
            .template(entry => {
                return `<a ui-sref="radniNalog.details({id:${entry.radni_nalog}})">${
                    entry.radni_nalog_sifra_naloga
                }</a>`;
            }),
        ac.field('napomena').label('Napomena'),
        ac
            .field('termin_probe', 'template')
            .label('<i class="fa fa-clock-o"></i>Termin')
            .template(entry => {
                return `<h4>${entry.termin_probe}</h4>`;
            })
            .cssClasses(['text-center'])
    ]);

    entity
        .editionView()
        .title('Izmjena faze naloga')
        .fields([
            Row([Column4([fields.datum_probe]), Column3([fields.termin_probe])]),
            Row([Column4([fields.tehnicar]), Column8([fields.napomena])])
        ]);

    return entity;
}



// WEBPACK FOOTER //
// ./app/components/fazaNaloga/config.js